<template>
  <div class="backup-codes">
    <div class="backup-codes__header">
      <div class="row items-center">
        <div class="col">
          <h6 class="inline-block q-ma-none">{{ $t('backup_codes') }}</h6>
        </div>
        <div class="col-auto">
          <copy-button :text="backupCodesText"></copy-button>
        </div>
      </div>
    </div>
    <div class="backup-codes__body">
      <span v-for="(backupCode, index) in backupCodes" :key="index">{{ backupCode }}</span>
    </div>
  </div>
</template>

<script>
  import CopyButton from 'components/Common/CopyButton.vue'

  export default {
    props: {
      backupCodes: {
        type: Array,
        required: true
      }
    },

    computed: {
      backupCodesText () {
        return this.backupCodes.reduce((carry, backupCode) => {
          return carry + backupCode + '\n'
        }, '')
      }
    },

    components: {
      CopyButton
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  .backup-codes
    border: 1px solid $border-color
    border-radius: $generic-border-radius

    &__header
      padding: 0.5rem 1rem
      border-bottom: 1px solid $border-color

    &__body
      padding: 1rem
      display: grid
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr
      grid-gap: 2rem
      background-color: $body-background
</style>
